import React, { Fragment } from "react";
import strings from "translate/language";

const UserList = (props) => {
  const {
    senderID = "",
    userList = [],
    handleUserChat = () => {},
    loadMore = () => {},
    onChangeInput = () => {},
    inputValue = "",
    listLabel = "",
    totalUsers = 0,
    isLoading = false,
    isListLabel = false,
    isSearchInput = false,
  } = props;
  return (
    <Fragment>
      <div className="card">
        <div className="chat-body">
          <div className="chat-box">
            {/* <!-- Chat left side Start--> */}
            <div className="chat-left-aside">
              <div className="people-list" id="people-list">
                {isSearchInput && (
                  <div className="search">
                    <form className="theme-form">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="search"
                          value={inputValue}
                          onChange={(e) => onChangeInput(e.target.value)}
                        />
                        <i className="fa fa-search"></i>
                      </div>
                    </form>
                  </div>
                )}
                {isListLabel && (
                  <div className="name f-w-700 mb-3">{listLabel}</div>
                )}
                <ul className="list">
                  {userList.length > 0 ? (
                    userList.map((user, index) =>
                      user?.firebase_id === senderID ? null : (
                        <li key={index} className="clearfix">
                          <img
                            className="rounded-circle user-image"
                            src={
                              user.profile_picture
                                ? `${user.base_url}/${user.profile_picture}`
                                : "/assets/images/user_old.png"
                            }
                            alt={user.user_name}
                          />
                          {/* <div className="status-circle away online offline"></div> */}
                          <div
                            onClick={() => handleUserChat(user)}
                            className="about breadcrumb-item"
                          >
                            <div className="name">{user.user_name}</div>
                            <div className="status">{user.roles}</div>
                          </div>
                        </li>
                      )
                    )
                  ) : (
                    <li className="clearfix">{strings.dataNotFound}</li>
                  )}
                  {totalUsers > 9 && (
                    <li className="load-more">
                      <button
                        className="btn btn-color ml-5"
                        type="button"
                        onClick={loadMore}
                      >
                        {isLoading ? "Loading..." : "Load More"}
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            {/* <!-- Chat left side Ends--> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserList;
